var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"tip-text"},[_vm._v("页面不存在.")]),_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.handleBack}},[_vm._v("返回上一页")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }